"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cc = void 0;
/** The list of the types that the potential. */
exports.default = Object.freeze([
    'Ci',
    'Co',
    'Ei',
    'Eo',
    'Fi',
    'Fo',
    'Ii',
    'Io',
    'Ni',
    'No',
]);
/** A table of Potential to CC. */
exports.cc = Object.freeze({
    Ci: 'j',
    Co: 'i',
    Ei: 'd',
    Eo: 'c',
    Fi: 'f',
    Fo: 'e',
    Ii: 'b',
    Io: 'a',
    Ni: 'h',
    No: 'g',
});
//# sourceMappingURL=potential.js.map